import { render } from "./licenseModal.vue?vue&type=template&id=1f4ffc7a"
import script from "./licenseModal.vue?vue&type=script&lang=js"
export * from "./licenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__